export default "__VITE_ASSET__6Kbn8Tn4__"